/* Build Your Box (gt-box-builder section). Every price starts from ONE bag (no pack sizes). Each bag you add
   makes the whole box cheaper to ship, and that saving comes off every bag in the box.
   Model: snippets/gt-box-model.liquid, made by bundle-builder/model/pricing.py (this file mirrors it). */
(function () {
  const root = document.querySelector('.gtb');
  if (!root) return;
  const $ = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => [...el.querySelectorAll(s)];
  const money = (c) => '$' + (Math.round(c) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const share = Number(root.dataset.share || 90) / 100;  // share of the shipping saving the shopper gets
  let M = null;
  try { M = JSON.parse($('[data-model]').textContent); } catch (e) { M = null; }

  /* ---------- Shipping-saving model (mirror of model/pricing.py) ----------
     Each bag has a shipping footprint (effective billed oz, fitted to real ShipBob costs). A(W) is the box's
     shipping cost per footprint-oz and can only fall as the box gets bigger, so adding ANY bag lowers the
     shipping share of EVERY bag. Saving per bag = its single-bag shipping cost - its share of the box. */
  const A = (W) => M.abar[Math.min(M.abar.length, Math.max(1, Math.floor(W))) - 1];
  function bagCredit(k, q) {
    if (!M || !M.w[k]) return 0;
    let n = 0, W = 0;
    for (const kk in q) if (q[kk] > 0 && M.w[kk]) { n += q[kk]; W += M.w[kk] * q[kk]; }
    if (n < 2) return 0;
    return share * Math.max(0, M.c1[k] - (M.w[k] * A(W) + M.pick));
  }

  const packOf = (t) => { const m = /(\d+)\s*(pouch|pack|bag)/i.exec(t); return m ? Number(m[1]) : 1; };
  const groupOf = (t) => t.replace(/\d+\s*(pouches|pouch|packs|pack|bags|bag)/i, '').replace(/[\s/]+$/, '').trim();
  const monthsOf = (name) => {
    const n = name.toLowerCase();
    if (n.includes('week')) return null;
    const m = /(\d+)\s*month/.exec(n);
    return m ? Number(m[1]) : (n.includes('month') ? 1 : null);
  };

  const state = { mode: 'sub', every: 3 };

  /* ---------- Referral + rewards (with the rewards page, referral-app/HANDOFF.md) ----------
     Retired Oct 17: the box's own ?ref mode ($20 off via /discount/CODE, subscription only, $50 minimum) has no
     discount behind it any more. A friend's $50 now goes into their Savings Jar when they create an account on the
     rewards page, and they spend it there. REF stays null so the box builds and checks out normally; an old saved
     gt_ref is cleared so it can't send a friend to checkout with a dead code. */
  const REF_MIN = 5000;  const REF = (() => {
    try { localStorage.removeItem('gt_ref'); } catch (e) { /* storage blocked */ }
    return null;
  })();
  // Set by the rewards chat before this script runs: { rate: points per $1, points?: balance (logged-in only) }.
  const rewards = () => {
    const g = window.GTRewards;
    return g && Number(g.rate) > 0 ? { rate: Number(g.rate), points: typeof g.points === 'number' ? g.points : null } : null;
  };
  // What checkout charges for the products today. The page's shipping savings aren't applied at checkout yet
  // (needs a discount, see HANDOFF), so the $70 minimum and points use this, not the box total.
  const checkoutTotal = (r) => r.cartPrice;
  const steps = $$('.gtb-step').map((el) => {
    const data = JSON.parse(el.querySelector('[data-product]').textContent);
    const planMonths = {};
    data.plans.forEach((p) => { planMonths[p.id] = monthsOf(p.name); });
    // Variants that differ only by pack size form one group (PP: each "N Birds" label is one pack size).
    const groups = {};
    data.variants.forEach((v) => { (groups[groupOf(v.title)] = groups[groupOf(v.title)] || []).push(v); });
    const multi = Object.values(groups).some((g) => g.length > 1);
    const groupList = multi ? Object.values(groups) : [data.variants];
    return { el, key: el.dataset.key, data, planMonths, groupList, qty: {},
      split: !!el.querySelector('.gtb-qty[data-variant]:not([data-variant="all"])') };
  });

  const total = (s) => Object.values(s.qty).reduce((a, b) => a + b, 0);

  // Pick the variant group and selling plan for this step in the current mode.
  function planFor(s, v) {
    if (state.mode !== 'sub') return null;
    let best = null;
    v.allocs.forEach((a) => { if (s.planMonths[a.plan] === state.every && (!best || a.price < best.price)) best = a; });
    return best;
  }
  function groupFor(s) {
    const usable = s.groupList.map((g) => g.filter((v) => v.available)).filter((g) => g.length);
    if (state.mode === 'sub') {
      const ok = usable.find((g) => g.every((v) => planFor(s, v)));
      if (ok) return ok;
    }
    return usable[0] || [];
  }
  // Cart lines: the single bag / single pouch variant only (no pack sizes). For Hen Harmony the flock-size
  // group is the one whose plan matches the chosen delivery schedule.
  function linesFor(s) {
    const out = [];
    if (s.split) {
      Object.entries(s.qty).forEach(([id, q]) => {
        const v = s.data.variants.find((x) => String(x.id) === id);
        if (v && q > 0) out.push({ v, q, plan: planFor(s, v) });
      });
      return out;
    }
    const n = total(s); if (!n) return out;
    const g = groupFor(s);
    const v = g.find((x) => packOf(x.title) === 1) || g[0];
    if (v) out.push({ v, q: n, plan: planFor(s, v) });
    return out;
  }
  const unitPrice = (s) => {
    const g = s.split ? s.data.variants : groupFor(s);
    const one = g.find((v) => packOf(v.title) === 1) || g[0];
    return one ? one.price : 0;
  };
  // Money for one product in box q (cents). Shipping saving comes off first, then Subscribe & Save %,
  // the same order the product-page packs use.
  function stepMoney(s, q) {
    const cr = Math.round(bagCredit(s.key, q) * 100);
    let n = 0, list = 0, once = 0, sub = 0;
    linesFor(s).forEach((l) => {
      const p1 = l.v.price, ps = l.plan ? l.plan.price : p1, u = Math.max(0, p1 - cr);
      n += l.q; list += p1 * l.q; once += u * l.q; sub += Math.round(u * ps / p1) * l.q;
    });
    return { n, cr, list, once, sub, pay: state.mode === 'sub' ? sub : once };
  }
  const qtyMap = () => { const q = {}; steps.forEach((s) => { q[s.key] = (q[s.key] || 0) + total(s); }); return q; };
  const shipTotal = (q) => Object.keys(q).reduce((a, k) => a + (q[k] || 0) * Math.round(bagCredit(k, q) * 100), 0);
  function compute() {
    const q = qtyMap();
    let list = 0, once = 0, sub = 0, cartPrice = 0; const per = {}, lines = [];
    steps.forEach((s) => {
      if (!total(s)) return;
      const m = stepMoney(s, q); per[s.key] = m;
      list += m.list; once += m.once; sub += m.sub;
      linesFor(s).forEach((l) => {
        cartPrice += (state.mode === 'sub' && l.plan ? l.plan.price : l.v.price) * l.q;
        lines.push(Object.assign({ step: s }, l));
      });
    });
    const pay = state.mode === 'sub' ? sub : once;
    // fnDiscount = what the checkout discount must take off the cart (cart lines are full single-bag prices).
    return { q, per, list, once, sub, box: list - once, pay, saved: list - pay, lines, cartPrice, fnDiscount: cartPrice - pay,
      units: Object.values(q).reduce((a, b) => a + b, 0) };
  }
  root.gtbModel = { bagCredit, shipTotal, compute: () => compute() };  // for QA parity checks against model/pricing.py

  /* ---------- Celebration: confetti + floating "You saved" pop, like a game pickup ---------- */
  const calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  const COLORS = ['#f2b233', '#1f6223', '#7bc96f', '#4f2c82', '#ffffff', '#e8604c'];
  let cv, cx, parts = [], raf = 0;
  function confetti(x, y, n, power) {
    if (calm) return;
    if (!cv) {
      cv = document.createElement('canvas'); cv.className = 'gtb-confetti'; cv.setAttribute('aria-hidden', 'true');
      document.body.appendChild(cv); cx = cv.getContext('2d');
    }
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    if (cv.width !== innerWidth * dpr || cv.height !== innerHeight * dpr) { cv.width = innerWidth * dpr; cv.height = innerHeight * dpr; cx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    for (let i = 0; i < n; i++) {
      const a = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.1, v = power * (0.55 + Math.random() * 0.6);
      parts.push({ x, y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, w: 5 + Math.random() * 5, h: 8 + Math.random() * 6,
        r: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.4, c: COLORS[i % COLORS.length], life: 0, max: 70 + Math.random() * 40 });
    }
    if (!raf) raf = requestAnimationFrame(tick);
  }
  function tick() {
    cx.clearRect(0, 0, innerWidth, innerHeight);
    parts = parts.filter((p) => p.life < p.max && p.y < innerHeight + 40);
    parts.forEach((p) => {
      p.life++; p.vy += 0.32; p.vx *= 0.985; p.x += p.vx; p.y += p.vy; p.r += p.vr;
      cx.save(); cx.globalAlpha = Math.max(0, 1 - p.life / p.max); cx.translate(p.x, p.y); cx.rotate(p.r);
      cx.fillStyle = p.c; cx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h * Math.abs(Math.cos(p.life / 6))); cx.restore();
    });
    raf = parts.length ? requestAnimationFrame(tick) : 0;
    if (!raf) cx.clearRect(0, 0, innerWidth, innerHeight);
  }
  function pop(x, y, text, big, loss) {
    const el = document.createElement('div');
    el.className = 'gtb-pop' + (big ? ' gtb-pop--big' : '') + (loss ? ' gtb-pop--loss' : '');
    // One small bubble at a time, so fast clicks don't stack them on top of each other.
    if (!big) document.querySelectorAll('.gtb-pop:not(.gtb-pop--big)').forEach((x) => x.remove());
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = text;
    el.style.top = Math.max(big ? 190 : 140, y) + 'px';
    document.body.appendChild(el);
    // Keep the whole pill on screen (it's centred on x).
    const half = el.offsetWidth * 0.56 + 8;  // 0.56 = half width at the 1.12x pop scale
    el.style.left = Math.max(half, Math.min(innerWidth - half, x)) + 'px';
    setTimeout(() => el.remove(), big ? 2600 : 1500);
  }
  const live = document.createElement('p'); live.className = 'gtb-sr'; live.setAttribute('aria-live', 'polite'); root.appendChild(live);
  function celebrate(btn, saved, unlocked) {
    const b = btn && btn.isConnected ? btn.getBoundingClientRect() : { left: innerWidth / 2, width: 0, top: innerHeight / 2 };
    const x = b.left + b.width / 2, y = b.top;
    confetti(x, y, unlocked ? 70 : 34, unlocked ? 13 : 10);
    pop(x, y - 8, unlocked ? `Shipping credit unlocked!<b>+${money(saved)} saved</b>` : `<b>+${money(saved)} saved!</b>`, unlocked);
    live.textContent = `You saved ${money(saved)}.`;
    if (navigator.vibrate) { try { navigator.vibrate(unlocked ? [12, 40, 18] : 12); } catch (e) { /* not allowed */ } }
  }
  // Numbers roll up or down to their new value, like a score counter.
  const tweens = new WeakMap();
  function tween(el, to, draw, start) {
    const t = tweens.get(el) || { v: start === undefined ? to : start, raf: 0 };
    cancelAnimationFrame(t.raf);
    const from = t.v, t0 = performance.now(), dur = calm || from === to ? 0 : 650;
    const frame = (now) => {
      const k = dur ? Math.min(1, (now - t0) / dur) : 1, e = 1 - Math.pow(1 - k, 3);
      t.v = from + (to - from) * e; draw(t.v);
      if (k < 1) t.raf = requestAnimationFrame(frame); else t.v = to;
    };
    tweens.set(el, t);
    frame(t0);
    // Browsers pause animation frames in background tabs; always land on the real number.
    clearTimeout(t.end);
    t.end = setTimeout(() => { if (t.v !== to) { cancelAnimationFrame(t.raf); t.v = to; draw(to); } }, dur + 120);
  }
  // Stop a running roll-up before clearing an element, or its last frames would redraw the old number.
  function stopTween(el) {
    const t = tweens.get(el);
    if (t) { cancelAnimationFrame(t.raf); clearTimeout(t.end); tweens.delete(el); }
  }
  const countTo = (el, to) => tween(el, to, (v) => { el.innerHTML = `You're saving <b>${money(v)}</b> on this box`; }, 0);
  function lose(btn, amount) {
    const b = btn && btn.isConnected ? btn.getBoundingClientRect() : { left: innerWidth / 2, width: 0, top: innerHeight / 2 };
    pop(b.left + b.width / 2, b.top - 8, `<b>−${money(amount)}</b>savings`, false, true);
    live.textContent = `Savings down ${money(amount)}.`;
  }

  // Per-product numbers: what this product costs per bag and what it saves. Only this product's own savings
  // (its packs, Subscribe & Save, and its own bags shipping together) count here, so adding a different
  // product never moves another product's per-bag price. The mixing credit shows in the box summary.
  function stepNumbers(s, r) {
    const m = r.per[s.key];
    if (!m || !m.n) return null;
    return { n: m.n, per: m.pay / m.n, list1: unitPrice(s), saved: m.list - m.pay };
  }

  let last = compute();
  function render(changed) {
    const r = compute();
    if (r.units) warmBoxApi();
    steps.forEach((s) => {
      const g = s.split ? s.data.variants : groupFor(s);
      const one = g.find((v) => packOf(v.title) === 1) || g[0];
      const p = one && planFor(s, one);
      const tag = $('[data-unit-price]', s.el);
      const nums = stepNumbers(s, r);
      if (nums) {
        // Live per-bag price for the quantity in the box, rolling as it changes.
        const each = nums.list1 - nums.per;
        tween(tag, nums.per, (v) => {
          tag.innerHTML = `<s>${money(nums.list1)}</s> <b class="gtb-per">${money(v)}</b> per ${s.data.unit}` +
            (each > 0.5 ? ` <span class="gtb-each">save ${money(nums.list1 - v)} each</span>` : '');
        });
      } else if (one) {
        stopTween(tag);
        tag.innerHTML = p ? `<s>${money(one.price)}</s> <b>${money(p.price)}</b> per ${s.data.unit}` : `<b>${money(one.price)}</b> per ${s.data.unit}`;
      }
      // Top-of-card badge: running total saved on this product.
      const badge = $('[data-saved]', s.el);
      if (nums && nums.saved > 0.004) {
        tween(badge, nums.saved, (v) => { badge.innerHTML = `You're saving <b>${money(v)}</b>`; }, 0);
      } else { stopTween(badge); badge.textContent = ''; }
      $$('.gtb-qty', s.el).forEach((row) => {
        const id = row.dataset.variant;
        const v = id === 'all' ? total(s) : (s.qty[id] || 0);
        const inp = row.querySelector('.gtb-qty__v');
        if (document.activeElement !== inp) inp.value = v;
        row.querySelector('[data-d="-1"]').disabled = v <= 0;
      });
      s.el.classList.toggle('is-filled', total(s) > 0);
    });
    const grew = !!(changed && changed.dir > 0 && r.saved > last.saved);
    if (changed) {
      const d = r.saved - last.saved;
      const badge = $('[data-saved]', changed.el);
      const delta = changed.el.querySelector('[data-delta]');
      if (Math.abs(d) > 0.004) {
        delta.textContent = (d > 0 ? '+' : '−') + money(Math.abs(d));
        delta.className = 'gtb-delta ' + (d > 0 ? 'is-up' : 'is-down');
        void delta.offsetWidth; delta.classList.add('is-show');
      }
      if (d > 0 && changed.dir > 0) {
        badge.classList.remove('is-pop', 'is-drop'); void badge.offsetWidth; badge.classList.add('is-pop');
        celebrate(changed.btn, d, last.box === 0 && r.box > 0);
      } else if (d < 0 && changed.dir < 0) {
        badge.classList.remove('is-pop', 'is-drop'); void badge.offsetWidth; badge.classList.add('is-drop');
        lose(changed.btn, -d);
      }
    }
    last = r;

    // Summary
    const has = r.units > 0;
    $('[data-empty]').hidden = has; $('[data-math]').hidden = !has;
    // One summary line per product (per scent for Coop), at the same price the step shows.
    // Every line shows its regular price struck through, its box price, and what the shopper saves on it.
    const linesHtml = r.lines.map((l) => {
      const m = r.per[l.step.key], u = Math.max(0, l.v.price - m.cr);
      const each = state.mode === 'sub' && l.plan ? Math.round(u * l.plan.price / l.v.price) : u;
      const reg = l.v.price * l.q, now = each * l.q, off = reg - now;
      return `<li><img src="${l.step.data.img}" alt="" width="44" height="44" loading="lazy">`
        + `<div class="gtb-line__main"><span class="gtb-line__name">${l.q} × ${l.step.data.name}${l.step.split ? ' · ' + l.v.title : ''}</span>`
        + `<span class="gtb-line__each">${money(each)} each</span>`
        + (off > 0 ? `<span class="gtb-line__save">You save ${money(off)}</span>` : '') + `</div>`
        + `<div class="gtb-line__price">${off > 0 ? `<s>${money(reg)}</s>` : ''}<b>${money(now)}</b></div></li>`;
    }).join('');
    $('[data-lines]').innerHTML = linesHtml;
    const sheetLines = $('[data-sheet-lines]'); if (sheetLines) sheetLines.innerHTML = linesHtml;
    $('[data-list]').textContent = money(r.list);
    const subSave = state.mode === 'sub' ? r.once - r.sub : 0;
    $('[data-row-pack]').hidden = true;
    $('[data-row-sub]').hidden = subSave <= 0; $('[data-sub]').textContent = '−' + money(subSave);
    $('[data-row-box]').hidden = r.box <= 0; $('[data-box]').textContent = '−' + money(r.box);
    $('[data-total]').textContent = money(r.pay);
    const ts = $('[data-total-saved]');
    ts.hidden = r.saved <= 0; countTo(ts, r.saved);
    if (grew) { ts.classList.remove('is-pop'); void ts.offsetWidth; ts.classList.add('is-pop'); }
    // Shipping is charged at checkout: $6.98 under $99.99, free from $99.99
    const shipTxt = r.pay >= 9999 ? ' FREE shipping on this box.' : ' Plus $6.98 shipping at checkout (FREE from $99.99).';
    $('[data-fine]').textContent = !has ? '' : (state.mode === 'sub'
      ? `Ships every ${state.every === 1 ? 'month' : state.every + ' months'}. Skip or cancel anytime.`
      : 'One box, shipped once. No subscription.') + shipTxt;
    // Referral minimum + points
    const ct = checkoutTotal(r), rw = rewards();
    const refShort = REF && has && ct < REF_MIN ? REF_MIN - ct : 0;
    const refMin = $('[data-ref-min]');
    if (refMin) { refMin.hidden = !refShort; refMin.textContent = refShort ? `Add ${money(refShort)} more to get $20 off this box ($50 minimum).` : ''; }
    const pts = $('[data-points]');
    // 1 point = 1¢, and the rewards page shows only dollars, so say it in dollars here too.
    if (pts) { const n = rw && has ? Math.floor(ct / 100 * rw.rate) : 0; pts.hidden = !n; pts.textContent = n ? `This box adds about ${money(n)} to your savings jar` : ''; }
    const sn = $('[data-sheet-note]');
    if (sn) { const t = [refMin && !refMin.hidden ? refMin.textContent : '', pts && !pts.hidden ? pts.textContent : ''].filter(Boolean); sn.hidden = !t.length; sn.textContent = t.join(' · '); }
    if (!adding) addBtns.forEach((b) => { b.disabled = !has; });
    $('[data-bar]').hidden = !has;
    if (!has) closeSheet();
    $('[data-bar-count]').textContent = `${r.units} ${r.units === 1 ? 'item' : 'items'}`;
    $('[data-bar-reg]').textContent = r.saved > 0 ? money(r.list) : '';
    $('[data-bar-total]').textContent = money(r.pay);
    $('[data-bar-saved]').textContent = r.saved > 0 ? `You save ${money(r.saved)}` : '';
    // Slide-up panel: same lines + the money rows.
    const sm = $('[data-sheet-math]');
    if (sm) {
      const row = (label, val, cls) => `<div class="${cls || ''}"><dt>${label}</dt><dd>${val}</dd></div>`;
      sm.innerHTML = row('Regular price', money(r.list))
        + (subSave > 0 ? row('Subscribe &amp; Save', '−' + money(subSave), 'is-save') : '')
        + (r.box > 0 ? row('Bundle savings', '−' + money(r.box), 'is-save is-box') : '')
        + row('Your box', money(r.pay), 'gtb-sum__total');
      $('[data-sheet-saved]').innerHTML = r.saved > 0 ? `You're saving <b>${money(r.saved)}</b> on this box` : '';
      $('[data-sheet-reg]').textContent = r.saved > 0 ? money(r.list) : '';
      $('[data-sheet-total]').textContent = money(r.pay);
      $('[data-sheet-save]').textContent = r.saved > 0 ? `You save ${money(r.saved)}` : '';
      $('[data-sheet-fine]').textContent = $('[data-fine]').textContent;
    }
  }

  const MAX_TYPED = 999;  // only a guard against typos like 1000000; no business cap
  function bump(s, id, dir, btn) {
    const k = s.split ? id : 'all';
    const v = (s.qty[k] || 0) + dir;
    if (v < 0 || v > MAX_TYPED) return;
    s.qty[k] = v;
    render({ el: s.el, dir, btn });
  }
  function setQty(s, id, raw, inp) {
    const k = s.split ? id : 'all';
    const old = s.qty[k] || 0;
    const v = Math.max(0, Math.min(MAX_TYPED, Math.floor(Number(raw)) || 0));
    inp.value = v;
    if (v === old) return;
    s.qty[k] = v;
    render({ el: s.el, dir: Math.sign(v - old), btn: inp });
  }
  steps.forEach((s) => {
    s.el.addEventListener('click', (e) => {
      const b = e.target.closest('.gtb-qty__b'); if (!b) return;
      bump(s, b.closest('.gtb-qty').dataset.variant, Number(b.dataset.d), b);
    });
    // Shoppers can also type any quantity.
    s.el.addEventListener('change', (e) => {
      const inp = e.target.closest('.gtb-qty__v'); if (!inp) return;
      setQty(s, inp.closest('.gtb-qty').dataset.variant, inp.value, inp);
    });
    s.el.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.closest('.gtb-qty__v')) { e.preventDefault(); e.target.blur(); }
    });
  });
  root.addEventListener('click', (e) => {
    const info = e.target.closest('[data-info]');
    if (info) { const t = $('[data-info-txt]'); t.hidden = !t.hidden; info.setAttribute('aria-expanded', String(!t.hidden)); }
  });
  $$('.gtb-mode__opt').forEach((b) => b.addEventListener('click', () => {
    state.mode = b.dataset.mode;
    $$('.gtb-mode__opt').forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-checked', String(x === b)); });
    $('[data-every-wrap]').hidden = state.mode !== 'sub';
    render();
  }));
  // Only offer a schedule every product can ship on. An interval appears on its own once each product
  // has an Appstle plan for it (e.g. 5 months needs a 5-month plan on Hen Harmony).
  const canShip = (m) => steps.every((s) => s.data.variants.some((v) => v.available && v.allocs.some((a) => s.planMonths[a.plan] === m)));
  $$('[data-every]').forEach((b) => { b.hidden = !canShip(Number(b.dataset.every)); });
  if (!canShip(state.every)) {
    const first = $$('[data-every]').find((b) => !b.hidden);
    if (first) { state.every = Number(first.dataset.every); $$('[data-every]').forEach((x) => { x.classList.toggle('is-on', x === first); x.setAttribute('aria-checked', String(x === first)); }); }
  }
  $$('[data-every]').forEach((b) => b.addEventListener('click', () => {
    state.every = Number(b.dataset.every);
    $$('[data-every]').forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-checked', String(x === b)); });
    render();
  }));

  /* Box savings at checkout (box-checkout app, see bundle-builder/FINALIZE-HANDOFF.md). The app re-prices the box from
     Shopify itself and only returns a code when its amount equals the page's to the cent. The code works once, for
     about an hour, only on this box's products, and only on a cart at least this big. Any failure = plain checkout. */
  const BOX_API = root.dataset.boxApi || '';
  if (BOX_API) {
    // Open the connection now so the Checkout tap doesn't pay for it.
    const l = document.createElement('link'); l.rel = 'preconnect'; l.href = new URL(BOX_API).origin; l.crossOrigin = 'anonymous';
    document.head.appendChild(l);
  }
  // Wake the code app once, when the box gets its first bag, so the Checkout tap never waits for a cold start.
  // (render() can run before this line, so no let/const here.)
  function warmBoxApi() {
    const api = root.dataset.boxApi;
    if (!api || root.dataset.warmed) return;
    root.dataset.warmed = '1';
    fetch(api + '?warm=1').catch(() => {});
  }
  async function boxSavingsCode(items, expect, tries = 2) {
    if (!BOX_API || !(expect > 0)) return null;
    const code = await boxSavingsCodeOnce(items, expect);
    return code || (tries > 1 ? boxSavingsCode(items, expect, tries - 1) : null);
  }
  async function boxSavingsCodeOnce(items, expect) {
    const ctl = new AbortController(), timer = setTimeout(() => ctl.abort(), 8000);
    try {
      // text/plain = a "simple" request: no CORS preflight round trip before the real call.
      const res = await fetch(BOX_API, { method: 'POST', signal: ctl.signal, headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({ expect, lines: items.map((i) => ({ id: i.id, quantity: i.quantity, selling_plan: i.selling_plan || null })) }) });
      const j = res.ok ? await res.json() : null;
      return j && j.code && j.amount === expect ? j.code : null;
    } catch (e) { return null; } finally { clearTimeout(timer); }
  }

  // Put the codes (and the referral attribute) on the cart in one write, and wait until Shopify accepts the box code
  // (a brand-new code can take a moment). The write returns the cart, so most taps need no extra read.
  async function applyCodes(root, json, body, boxCode) {
    for (let i = 0; i < 4; i++) {
      let cart = await fetch(root + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify(body) })
        .then((x) => (x.ok ? x.json() : null)).catch(() => null);
      if (!boxCode) return;
      if (!cart || !Array.isArray(cart.discount_codes)) {
        cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((x) => x.json()).catch(() => null);
      }
      const c = cart && (cart.discount_codes || []).find((d) => d.code === boxCode);
      if (c && c.applicable) return;
      await new Promise((ok) => setTimeout(ok, 1200));
    }
  }

  /* Packing screen (Oct 25, Michael): from the Checkout tap until Shopify's checkout shows, the shopper watches their
     box get packed and each real step tick off, so the wait reads as progress instead of a stuck button. It stays up
     while the checkout page loads (the browser keeps this page on screen until the next one paints). */
  function packingScreen(r) {
    const el = document.createElement('div');
    el.className = 'gtb-pack' + (calm ? ' is-calm' : '');
    el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-labelledby', 'gtb-pack-h');
    /* One bag per unit, tossed in fast from alternating sides (Michael, Oct 25: "us throwing a bunch of stuff in the
       box"). Every throw lands within ~1 s, inside the time the cart itself takes. Big boxes throw a sample (14 max)
       in proportion, with every product thrown at least once. */
    const CAP = 14;
    const count = r.lines.map((l) => (r.units > CAP ? Math.max(1, Math.round(l.q * CAP / r.units)) : l.q));
    while (count.reduce((a, b) => a + b, 0) > CAP) { const big = count.indexOf(Math.max(...count)); count[big]--; }
    const throws = [];
    r.lines.forEach((l, i) => { for (let k = 0; k < count[i]; k++) throws.push(l.step.data.img); });
    const n = throws.length, gap = n > 1 ? Math.min(0.11, 0.6 / (n - 1)) : 0, rnd = (a, b) => a + Math.random() * (b - a);
    const items = throws.map((img, i) => {
      const side = i % 2 ? 1 : -1;
      const style = `--d:${(0.05 + i * gap).toFixed(3)}s;--x:${rnd(20, 80).toFixed(1)}%;--y:${(68 - (i / Math.max(1, n - 1)) * 14 + rnd(-3, 3)).toFixed(1)}px;`
        + `--r:${rnd(-28, 28).toFixed(0)}deg;--r0:${side * rnd(140, 220).toFixed(0)}deg;--fx:${side * rnd(150, 190).toFixed(0)}px`;
      return `<span class="gtb-pack__item" style="${style}"><img src="${img}" alt="" width="46" height="46"></span>`;
    }).join('');
    const landed = performance.now() + (calm ? 0 : (0.05 + (n - 1) * gap + 0.34) * 1000);
    const save = r.saved > 0 ? `Locking in your ${money(r.saved)} savings` : 'Locking in your price';
    el.innerHTML = `<div class="gtb-pack__card">`
      + `<div class="gtb-pack__scene" aria-hidden="true"><div class="gtb-pack__back"></div><div class="gtb-pack__items">${items}</div>`
      + `<div class="gtb-pack__front"><span>GrubTerra</span></div><div class="gtb-pack__flap gtb-pack__flap--l"></div>`
      + `<div class="gtb-pack__flap gtb-pack__flap--r"></div><div class="gtb-pack__tape"></div><div class="gtb-pack__ok">✓</div></div>`
      + `<h2 class="gtb-pack__h" id="gtb-pack-h" tabindex="-1">Packing your box…</h2>`
      + `<ol class="gtb-pack__steps" aria-live="polite">`
      + `<li class="is-on">Packing ${r.units} ${r.units === 1 ? 'item' : 'items'} into your box</li>`
      + `<li>${save}</li><li>Opening secure checkout</li></ol>`
      + `<p class="gtb-pack__note">🔒 Secure checkout by Shopify</p></div>`;
    document.body.appendChild(el);
    const html = document.documentElement, overflow = html.style.overflow;
    html.style.overflow = 'hidden';
    requestAnimationFrame(() => { el.classList.add('is-in'); $('.gtb-pack__h', el).focus({ preventScroll: true }); });
    const steps = $$('.gtb-pack__steps li', el);
    return {
      // Step i finished; text replaces its label (used when the savings code didn't come back).
      done(i, text) {
        if (text) steps[i].textContent = text;
        steps[i].classList.remove('is-on'); steps[i].classList.add('is-done');
        if (steps[i + 1]) steps[i + 1].classList.add('is-on');
        if (i === 0) $('.gtb-pack__h', el).textContent = 'Locking in your savings…';
        if (i === steps.length - 2) {
          // Close the flaps only after the last throw has landed.
          setTimeout(() => el.classList.add('is-packed'), Math.max(0, landed - performance.now()));
          $('.gtb-pack__h', el).textContent = 'Box packed! Opening checkout…';
        }
      },
      close() { el.remove(); html.style.overflow = overflow; },
    };
  }

  /* The free $0 e-book packs the cart drawer gives every subscription (gt-cart.js syncProtection), added in the same
     cart write as the box: one write instead of two, and nothing can land in between and wipe them. Same rule as the
     drawer; packs tied to specific products ("triggers") are left to the drawer. */
  function bonusPacks(cart) {
    let b = null;
    try { b = JSON.parse(document.getElementById('GTCartConfig').textContent).bonus; } catch (e) { return []; }
    if (!b || !b.enabled || !b.items || (b.subsOnly && state.mode !== 'sub')) return [];
    const have = new Set(((cart && cart.items) || []).map((i) => i.product_id));
    return b.items.filter((x) => x.variantId && !(x.triggers && x.triggers.length) && (x.price === 0 || b.discounted) && !have.has(x.productId))
      .map((x) => ({ id: x.variantId, quantity: 1 }));
  }

  /* The same checks drawer.refresh() runs on the cart (free gifts, e-book packs, Coop deals), in the same order, without
     re-drawing the drawer, which stays shut on the way to checkout. Falls back to refresh() if the drawer changes. */
  const CART_CHECKS = ['syncCoopFree', 'syncPPBulk', 'syncCoopRefill', 'syncGifts', 'syncProtection'];
  async function cartChecks(drawer) {
    if (!drawer || !drawer.fetchCart) return;
    try {
      if (!CART_CHECKS.every((f) => typeof drawer[f] === 'function')) { if (drawer.refresh) await drawer.refresh(); return; }
      drawer.cart = await drawer.fetchCart();
      for (const f of CART_CHECKS) await drawer[f]();
    } catch (e) { /* the drawer's own refresh after this page's cart writes repeats these checks */ }
  }

  let adding = false;
  let resetAdd = null;
  // Back button from checkout: the browser restores this page mid-"Going to checkout…" with the buttons locked.
  // Back button without the cache: the browser refills the quantity boxes but the box itself starts empty. Read them back.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted && resetAdd) resetAdd();
    const restored = $$('.gtb-qty__v').map((inp) => [inp, inp.value]);
    restored.forEach(([inp, v]) => { if (Number(v) > 0) { inp.value = v; inp.dispatchEvent(new Event('change', { bubbles: true })); } });
  });
  const addBtns = $$('[data-add], [data-add-bar], [data-add-sheet]');
  async function addBox(btn) {
    const r = compute(); if (!r.units || adding) return;
    adding = true; addBtns.forEach((b) => { b.disabled = true; });
    const errs = [$('[data-err]'), $('[data-sheet-err]')].filter(Boolean);
    errs.forEach((x) => { x.hidden = true; });
    const boxId = 'BOX-' + Date.now().toString(36).toUpperCase();
    const items = r.lines.map((l) => {
      const it = { id: l.v.id, quantity: l.q, properties: { _gt_box: boxId } };
      if (l.plan) it.selling_plan = l.plan.plan;
      return it;
    });
    // The savings code only needs the box, so ask for it now and let it run while the cart fills.
    const codeP = boxSavingsCode(items, r.fnDiscount);
    const label = btn.textContent; btn.textContent = 'Going to checkout…';
    const pack = packingScreen(r);
    // Straight to checkout (Michael, Oct 8): the cart drawer must not slide open on the way.
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.open = () => {};
    const done = () => { adding = false; btn.textContent = label; addBtns.forEach((b) => { b.disabled = false; }); if (drawer) delete drawer.open; pack.close(); resetAdd = null; };
    resetAdd = done;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const json = { 'Content-Type': 'application/json', Accept: 'application/json' };
    try {
      // The drawer keeps the cart it last read (on load and after every cart change); reuse it to skip a round trip.
      const cart = (drawer && drawer.cart && Array.isArray(drawer.cart.items)) ? drawer.cart
        : await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((x) => x.json()).catch(() => null);
      const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items.concat(bonusPacks(cart)) }) });
      if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.description || 'Something went wrong. Please try again.'); }
      // Coming back from checkout and tapping again: replace the box already in the cart, don't keep a second copy.
      // Removed AFTER the new box is in, so the cart is never empty for a moment (the drawer drops the free e-books
      // from an empty cart, and that's how a back-and-retry used to lose them).
      const old = {};
      ((cart && cart.items) || []).forEach((i) => { if (i.properties && i.properties._gt_box) old[i.key] = 0; });
      if (Object.keys(old).length) {
        await fetch(root + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: old }) });
      }
      // The cart still runs its own free-gift checks (it finds the packs already there, so no second add).
      await cartChecks(drawer);
      pack.done(0);
      const boxCode = await codeP;
      // Referral code rides on the order only when the box meets the minimum; clear a stale one otherwise.
      const codes = boxCode ? [boxCode] : [];
      const body = {};
      if (REF) {
        const ok = checkoutTotal(r) >= REF_MIN;
        body.attributes = { gt_ref: ok ? REF.code : '' };
        if (ok) codes.push(REF.code);
      }
      if (codes.length) body.discount = codes.join(',');
      // Fast path: a cart with no earlier box and no codes on it takes the code in the checkout link itself (saves a
      // ~0.75 s cart write). A back-and-retry or referral box still writes the codes to the cart, which replaces the
      // earlier box's code so checkout can't pick the old one.
      const fast = codes.length && !REF && !Object.keys(old).length && !((cart && cart.discount_codes) || []).length;
      if (!fast && (codes.length || REF)) await applyCodes(root, json, body, boxCode);
      pack.done(1, r.fnDiscount > 0 && !boxCode ? 'Getting your checkout ready' : null);
      window.location.href = root + 'checkout' + (fast ? '?discount=' + encodeURIComponent(body.discount) : '');
    } catch (e) {
      // Show the error where the shopper is looking: in the panel (opened for the bar's button) and in the card.
      done();
      errs.forEach((x) => { x.textContent = e.message; x.hidden = false; });
      if (btn.matches('[data-add-bar]')) openSheet();
    }
  }
  addBtns.forEach((b) => b.addEventListener('click', () => addBox(b)));

  /* ---------- Phone: slide-up "Your box" panel ---------- */
  const sheet = $('[data-sheet]'), sheetOpenBtn = $('[data-sheet-open]');
  function openSheet() {
    if (!sheet) return;
    sheet.hidden = false; document.documentElement.classList.add('gtb-locked');
    requestAnimationFrame(() => sheet.classList.add('is-open'));
    sheetOpenBtn.setAttribute('aria-expanded', 'true');
    const x = sheet.querySelector('.gtb-sheet__x'); if (x) x.focus();
  }
  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open'); document.documentElement.classList.remove('gtb-locked');
    sheetOpenBtn.setAttribute('aria-expanded', 'false');
    setTimeout(() => { sheet.hidden = true; }, calm ? 0 : 260);
    if (sheet.contains(document.activeElement)) sheetOpenBtn.focus();
  }
  if (sheet) {
    sheetOpenBtn.addEventListener('click', () => (sheet.hidden ? openSheet() : closeSheet()));
    sheet.addEventListener('click', (e) => { if (e.target.closest('[data-sheet-close]')) closeSheet(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSheet(); });
  }

  /* ---------- Reviews: one Loox widget, switched per product (tabs at the bottom, star links on each step) ---------- */
  function showReviews(pid, scroll) {
    const wrap = $('.gtb-reviews'); if (!wrap) return;
    $$('.gtb-reviews__tab', wrap).forEach((t) => {
      const on = t.dataset.review === String(pid);
      t.classList.toggle('is-on', on); t.setAttribute('aria-selected', String(on));
      if (on) { const bar = t.parentElement; bar.scrollTo({ left: t.offsetLeft - (bar.clientWidth - t.offsetWidth) / 2, behavior: calm ? 'auto' : 'smooth' }); }
    });
    const box = document.getElementById('looxReviews');
    if (box && box.dataset.productId !== String(pid)) {
      box.dataset.productId = String(pid);
      const fr = box.querySelector('iframe');
      if (fr) fr.src = fr.src.replace(/\/reviews\/\d+/, '/reviews/' + pid);
    }
    if (scroll) wrap.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
  }
  root.addEventListener('click', (e) => {
    const r = e.target.closest('[data-review]'); if (!r) return;
    e.preventDefault();
    showReviews(r.dataset.review, !r.classList.contains('gtb-reviews__tab'));
  });

  // Sticky bar stays until the box's own Checkout button is fully on screen above the bar's area
  // (Michael, Oct 8: it shouldn't disappear before you reach that button). It comes back after you scroll past it.
  const mainCta = $('[data-add]');
  if ('IntersectionObserver' in window && mainCta) {
    const bar = $('[data-bar]');
    new IntersectionObserver(([e]) => {
      root.classList.toggle('sum-visible', e.isIntersecting);
      bar.inert = e.isIntersecting;
    }, { threshold: 1, rootMargin: '0px 0px -140px 0px' }).observe(mainCta);
  }
  if (REF) {
    const b = $('[data-ref]');
    if (b) {
      b.querySelector('[data-ref-who]').textContent = REF.name ? `${REF.name} sent you` : 'A friend sent you';
      b.hidden = false;
    }
    // Subscription only: hide One-time and make sure Subscribe is picked.
    const once = $('.gtb-mode__opt[data-mode="once"]'), sub = $('.gtb-mode__opt[data-mode="sub"]');
    if (once) once.hidden = true;
    if (sub && state.mode !== 'sub') sub.click();
  }
  const rw0 = rewards(), pl = $('[data-points-link]');
  if (pl && rw0 && rw0.points !== null && rw0.points > 0 && !/grubterra-rewards/.test(location.pathname)) {
    pl.textContent = `You have ${money(rw0.points)} in your savings jar. Use it on this order →`;
    pl.hidden = false;
  }
  render();
})();
